export default __webpack_public_path__ + "static/media/baseline-bar_chart-24px.2e672fc9.svg";